import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import MetroNonServiceable from "../Components/MetroNonServiceable";

const MetroNonServiceableAdmin = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <Header />
      <Sidebar />
      <MetroNonServiceable />
      {/* <Footer/>    */}
    </>
  );
};

export default MetroNonServiceableAdmin;
